export function proximityFormat(a: number | undefined): string {
  if (a === undefined) return '-';
  if (a < 10) return `${a.toFixed(2)} mi`;
  if (a < 100) return `${a.toFixed(1)} mi`;
  return `${a.toFixed(0)} mi`;
}
